<template lang="pug">
.laudo-listagem.w-100
    .tabela(v-if='tableData.length > 0')
        el-table.w-100.my-3.rolagem-tabela-laudo(
            :data='tableData',
            @sort-change='sortChangeRequest'
        )
            el-table-column(
                prop='codigo',
                :label="$t('mensagens.laudos.gridColunaHash')",
                sortable='custom',
                align='left'
            )
            el-table-column(
                prop='informacaoLaudo.nomeTerritorio',
                :label="$t('mensagens.laudos.territorio')",
                sortable='custom',
                align='left'
            )
            el-table-column(
                prop='informacaoLaudo.nomeRepresentante',
                :label="$t('mensagens.laudos.pessoa')",
                sortable='custom',
                align='left'
            )
            el-table-column(
                prop='informacaoLaudo.referenciaBacen',
                label='Refbacen',
                sortable='custom',
                align='left'
            )
            el-table-column(
                prop='dataCadastroFormatado',
                :label="$t('mensagens.laudos.dataSolicitacao')",
                sortable='custom',
                align='left'
            )
            el-table-column(
                prop='dataFinalizacaoFormatado',
                :label="$t('mensagens.laudos.dataEntrega')",
                sortable='custom',
                align='left'
            )
            el-table-column(prop='situacao', :label="$t('mensagens.laudos.situacao')", sortable)
                .template(slot-scope='scope')
                    div(
                        :class='["situacao", classeSituacao.get(scope.row.situacao.codigo)]'
                    ) {{ traduzirSituacao(scope.row.situacao.nome) }}

            el-table-column(prop='status', :label="$t('mensagens.laudos.status')", sortable, align='left')
                .template(slot-scope='scope')
                    div(
                        v-if='scope.row.status && scope.row.situacao.codigo === "PROCESSADO"',
                        :class='["status", scope.row.status.codigo === "CONFORME" ? "conforme" : "inconforme"]'
                    )
                        | {{ scope.row.status ? scope.row.status.nome : '-' }}

            el-table-column(:label="$t('mensagens.comuns.acoes')" align='left')
                .template.d-flex.justify-content-left(slot-scope='scope')
                    el-dropdown.action-button(trigger='click')
                        span.el-dropdown-link
                            i.mdi.mdi-dots-vertical
                        el-dropdown-menu(slot='dropdown')
                            el-dropdown-item(
                                icon='el-icon-view',
                                @click.native='showModalVisualizacao(scope.row)'
                            ) {{ $t('mensagens.laudos.visualizarLaudo') }}
                            el-dropdown-item(
                                v-if='scope?.row?.situacao?.codigo === "NA_FILA"',
                                icon='el-icon-circle-close',
                                @click.native='showModalCancelarLaudo(scope.row)'
                            ) {{ $t('mensagens.laudos.cancelarLaudo') }}
                            el-dropdown-item(
                                v-if='scope.row.situacao.codigo === "PROCESSADO"',
                                icon='el-icon-download',
                                @click.native='downloadLaudo(scope.row)'
                            ) {{ $t('mensagens.laudos.baixarLaudo') }}
    EmptyResultLaudo(
         v-else
        :semLaudoSelecionado='false',
        :p1="$t('mensagens.comuns.semDados')",
        :p2="$t('mensagens.laudos.naoConseguimosLocalizarNenhumLaudo')"
    )
</template>

<script>
import LaudosService from '@/services/LaudosService';
import { classe } from '@/utils/laudoSituacao';

import EmptyResultLaudo from '@/components/laudos/EmptyResultLaudo.vue';

export default {
    name: 'LaudoListagem',
    components: {
        EmptyResultLaudo
    },
    props: {
        tableData: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            classeSituacao: classe
        };
    },
    created() {
    },
    methods: {
        traduzirSituacao(situacao) {
            const normalizedSituacao = situacao
                .toUpperCase()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .replace(/ /g, '-');

            return this.$t(
                `mensagens.relatorioCompartilhamentoDeDados.${normalizedSituacao}`
            );
        },
        showModalVisualizacao(row) {
            this.$emit('handleModalLaudo', row.id);
        },
        showModalCancelarLaudo(row) {
            this.$store.dispatch('processarEventoGoogleAnalytics', { eventLabel: 'VISUALIZAR_MODAL_CANCELAMENTO_LAUDOS', pageTitle: 'VISUALIZAR_MODAL_CANCELAMENTO_LAUDOS', routeName: this.$route?.name, routePath: this.$route?.path });
            this.$emit('handleModalCancelamento', row.id);
        },
        sortChangeRequest(column) {
            let prop = column.prop;
            if (prop.includes('.')) {
                prop = prop.split('.')[1];
            }

            if (prop === 'dataCadastroFormatado') {
                prop = 'dataCadastro';
            }
            if (prop === 'dataFinalizacaoFormatado') {
                prop = 'dataFinalizacao';
            }

            let params = {
                order: null,
                column: prop
            };

            if (column.order === 'ascending') {
                params.order = 'ASC';
            } else if (column.order === 'descending') {
                params.order = 'DESC';
            }

            this.$emit('handleSort', params);
        },
        downloadLaudo(laudo) {
            LaudosService.downloadLaudo(laudo.id)
                .then(() => {
                    this.$notify.success({
                        message: this.$t('mensagens.laudos.downloadRealizadoComSucesso')
                    });
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.$t('mensagens.laudos.erro.erroAoRealizarDownload')
                    });
                });
        }
    }
};
</script>

<style lang="scss">
.laudo-listagem {
    .el-table {
        .cell {
            word-break: break-word !important;
        }

        .action-button {
            cursor: pointer;
        }
    }

    .status {
        border-radius: 50px;
        text-align: center;
        color: var(--black);
        max-width: 150px;
    }

    .conforme {
        background-color: #d5f8d7;
        border: 1px solid #b0dcb3;
    }

    .nao-conforme {
        background-color: #f7d6da;
        border: 1px solid #e58585;
    }

    .buttonCard {
        background: var(--white);
        height: 60px;
        top: -15px;
        position: relative;
        padding: 10px;
    }
}
</style>
